import { buildProps, definePropType } from '@ll-plus/utils'

import Color from './color'

import type { ExtractPropTypes } from 'vue'

import type HueSlider from '../components/hue-slider.vue'

export const hueSliderProps = buildProps({
  color: {
    type: definePropType<Color>(Object),
    default: () => new Color()
  },
  vertical: {
    type: Boolean,
    default: false
  }
} as const)

// props
export type HueSliderProps = ExtractPropTypes<typeof hueSliderProps>

// instance
export type HueSliderInstance = InstanceType<typeof HueSlider>
